export const pageBySlugQuery = (slug: string, languageCode: string) => `
query PageBySlugQuery {
  pages(filters: { slug: { eq: "${slug}" } }, locale: "${languageCode}") {
    slug
    title
    components {
      ... on ComponentMainHeader {
        __component: __typename
        heroImage {
          documentId
          alternativeText
          width
          height
          formats
          url
        }
        slogan
        callToAction {
          link
          text
        }
      }
      ... on ComponentMainDivider {
        __component: __typename
        isVisible
      }
      ... on ComponentMainGallery {
        __component: __typename
        gallery {
          images {
            documentId
            alternativeText
            width
            height
            formats
            url
          }
        }
      }
      ... on ComponentMainTextImage {
        __component: __typename
        text
        buttonText
        textImage: image {
          documentId
          alternativeText
          width
          height
          formats
          url
        }
        buttonLink
        isImageLeft
      }
      ... on ComponentMainContact {
        __component: __typename
        statusText {
          failureText
          successText
        }
        contactInfoText: infoText
        gallery {
          images {
            alternativeText
            width
            height
            formats
            url
          }
        }
      }
      ... on ComponentMainTextField {
        __component: __typename
        textFieldContent: content
      }
      ... on ComponentMainTestimonials {
        __component: __typename
        testimonialsSubTitle: subTitle
        testimonialsTitle: title
        entries {
          name
          text
          image {
            documentId
            alternativeText
            width
            height
            formats
            url
          }
        }
      }
      ... on ComponentMainApartmentInfo {
        __component: __typename
        apartmentInfoSubTitle: subTitle
        apartmentInfoImage: image {
          alternativeText
          width
          height
          formats
          url
        }
        info
        bookingButton {
          link
          text
        }
        accordionEntries {
          text
          textFieldContent: content
        }
      }
      ... on ComponentMainTextFieldMarkdown {
        __component: __typename
        content
      }
      ... on ComponentMainContactHof {
        __component: __typename
        statusText {
          failureText
          successText
        }
        contactHofTitle: title
      }
      ... on ComponentMainSlider {
        __component: __typename
        gallery {
          images {
            alternativeText
            width
            height
            formats
            url
          }
        }
      }
      ... on ComponentMainBooking {
        __component: __typename
        name
        description
        statusText {
          failureText
          successText
        }
        gallery {
          images {
            alternativeText
            width
            height
            formats
            url
          }
        }
        map {
          latitude
          longitude
        }
      }
      ... on ComponentMainPriceView {
        __component: __typename
        priceViewTitle: title
      }
      ... on ComponentMainStart {
        __component: __typename
        left {
          text
          image {
            alternativeText
            width
            height
            formats
            url
          }
        }
        right {
          text
          image {
            alternativeText
            width
            height
            formats
            url
          }
        }
      }
      ... on ComponentMainHofPage {
        __component: __typename
        bestsellers {
          title
          products {
            documentId
            name
            slug
            price
            inventoryType
            variants {
              amount
              label
              uuid
              weight
            }
            images {
              alternativeText
              width
              height
              formats
              url
            }
            deliveryDates {
              documentId
              date
            }
          }
        }
        fullImages {
          image {
            alternativeText
            width
            height
            formats
            url
          }
          mobileImage {
            alternativeText
            width
            height
            formats
            url
          }
        }
        textImageOnly {
          text
          image {
            alternativeText
            width
            height
            formats
            url
          }
        }
        categories {
          name
          slug
          products {
            documentId
            name
            slug
            price
            images {
              alternativeText
              width
              height
              formats
              url
            }
          }
        }
      }
      ... on ComponentMainFullProduct {
        __component: __typename
        infoText
      }
      ... on ComponentMainMoreProducts {
        __component: __typename
        title
      }
      ... on ComponentMainShop {
        __component: __typename
        maxProducts
        categories {
          documentId
          name
          slug
          products(pagination: { pageSize: 50 }) {
            documentId
            name
            slug
            createdAt
            price
            productType
            inventoryType
            category {
              documentId
            }
            variants {
              amount
              label
              uuid
              weight
            }
            images {
              alternativeText
              width
              height
              formats
              url
            }
            deliveryDates {
              documentId
              date
            }
          }
          image {
            alternativeText
            width
            height
            formats
            url
          }
        }
      }
      ... on ComponentMainYoutubeVideo {
        __component: __typename
        linkItem {
          link
          text
        }
      }
      ... on ComponentMainBlog {
        __component: __typename
        maxBlogPosts
      }
      ... on ComponentMainFullBlogPost {
        __component: __typename
        infoText
      }
      ... on ComponentMainNewsletterPopup {
        __component: __typename
        title
        subTitle
        popupAfterSeconds
        newsletterPopupImage: image {
          alternativeText
          width
          height
          formats
          url
        }
      }
      ... on ComponentMainNewsletter {
        __component: __typename
        title
        subTitle
        hasAddress
      }
      ... on ComponentMainFullImage {
        __component: __typename
        image {
          alternativeText
          width
          height
          formats
          url
        }
      }
      ... on ComponentMainPartner {
        __component: __typename
        images {
          alternativeText
          width
          height
          formats
          url
        }
      }
      ... on ComponentMainMap {
        __component: __typename
        latitude
        longitude
      }
      ... on ComponentMainAnimals {
        __component: __typename
        textFields {
          textFieldContent: content
        }
      }
      ... on ComponentMainImageWithFiveCaptions {
        __component: __typename
        image {
          alternativeText
          width
          height
          formats
          url
        }
        captions {
          link
          text
        }
      }
      ... on Error {
        __component: __typename
        code
        message
      }
    }
    seo {
      metaTitle
      metaDescription
      metaKeywords
      canonicalURL
      metaRobots
      structuredData
      facebook {
        title
        description
        image {
          alternativeText
          width
          height
          formats
          url
        }
      }
      twitter {
        title
        description
        image {
          alternativeText
          width
          height
          formats
          url
        }
      }
    }
  }
}

`;
